import React from "react";
import ContentLoader from "react-content-loader";

import { OptionList, OptionRow } from "components/EntryOption/styles";

// Esqueleto de los pasos de selección. Sigue la silueta de la fila (rótulo,
// título, dos líneas de descripción y las acciones a la derecha) para que al
// cargar no salte el layout.
export default function OptionLoader({ counter }) {
  const rows = Array.from(Array(counter).keys());

  return (
    <OptionList>
      {rows.map((row) => (
        <OptionRow key={row}>
          <ContentLoader
            speed={2}
            width="100%"
            height={78}
            viewBox="0 0 600 78"
            preserveAspectRatio="none"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="0" rx="4" ry="4" width="62" height="15" />
            <rect x="0" y="25" rx="4" ry="4" width="260" height="20" />
            <rect x="0" y="55" rx="4" ry="4" width="520" height="12" />
          </ContentLoader>

          <ContentLoader
            speed={2}
            width={130}
            height={40}
            viewBox="0 0 130 40"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="0" rx="8" ry="8" width="130" height="40" />
          </ContentLoader>
        </OptionRow>
      ))}
    </OptionList>
  );
}
